module.exports = __webpack_public_path__ + "images/landing/banner/help-img-2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-2.png
// module id = tV+N
// module chunks = 118